import React, {
  Fragment,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import ti from "../../svg/ti.png";
import x3 from "../../svg/x3.png";
import qr from "../../svg/tik-qr.png";
import bgTickets from "../../svg/bg-tickets.png";
import logo1 from "../../svg/logo1.png";
import ticketIcon from "../../svg/ticket-icon.png";
import ticketPin from "../../svg/tickets-pin.png";

const TicketForm = (props) => {
  const [inputValues, setInputValues] = useState({});
  const [open, setOpen] = useState(false);
  const [obj, setObj] = useState([]);
  const cancelButtonRef = useRef(null);
  const [t, i18n] = useTranslation("global");
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);
  const form = useRef();
  const [loading, setLoading] = useState(true);
  const [showGreencheck, setShowGreencheck] = useState(
    Array(props.numberTickets).fill().map(() => ({
      nameOk: false,
      emailOk: false,
      discountOk: false,
    }))
  );
  const [activeTickets, setActiveTickets] = useState(
  Array.from({ length: props.numberTickets }, () => true)
);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_TOKEN = process.env.REACT_APP_API_TOKEN;
  const CONVENTION_ID = process.env.REACT_APP_CONVENTION_ID;
  const [showOK, setShowOK] = useState(
    "bg-slate-400 text-white px-6 xl:w-fit w-full sm:w-auto h-32 text-4xl md:text-5xl cursor-not-allowed whitespace-nowrap"
  );
  const [discounts, setDiscounts] = useState(
    Array(props.numberTickets).fill(0)
  );
  const [previousNumberOfTickets, setPreviousNumberOfTickets] = useState(
    props.numberTickets
  );
  const [isScreenSmall, setIsScreenSmall] = useState(false);
  const [discountData, setDiscountData] = useState({});

  useEffect(() => {
    const handleNumberOfTicketsIncrease = () => {
      setShowOK(
        "bg-slate-400 text-white px-6 xl:w-fit w-full sm:w-auto h-32 text-4xl md:text-5xl whitespace-nowrap"
      );
      forceUpdate();
    };

    if (props.numberTickets > previousNumberOfTickets) {
      handleNumberOfTicketsIncrease();
    } else if (props.numberTickets < previousNumberOfTickets) {
      obj.forEach((item, index) => {
        const fakeEvent = {
          target: {
            id: index,
            name: item.name,
            email: item.email,
            discount: item.discount,
            value: item.name,
            deleteId: 0,
          },
        };
        handleChangeName(fakeEvent);
      });
    }

    setActiveTickets((prev) => {
      const next = [...prev];
      if (props.numberTickets > prev.length) {
        return [...next, ...Array(props.numberTickets - prev.length).fill(true)];
      }
      return next.slice(0, props.numberTickets);
    });

    refresh_total();
    setPreviousNumberOfTickets(props.numberTickets);

    const handleResize = () => {
      setIsScreenSmall(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, [props.numberTickets, previousNumberOfTickets]);

  useEffect(() => {
  if (showGreencheck.length !== props.numberTickets) {
    const diff = props.numberTickets - showGreencheck.length;
    if (diff > 0) {
      setShowGreencheck(prev => [
        ...prev,
        ...Array(diff).fill({ nameOk: false, emailOk: false, discountOk: false })
      ]);
    } else {
      setShowGreencheck(prev => prev.slice(0, props.numberTickets));
    }
  }
}, [props.numberTickets]);


  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const handleClose = (event) => {
    setOpen(false);
  };

  const handleChangeName = (event) => {
      const index = Number(event.target.id);
      const cloned = [...showGreencheck];
      cloned[index] = { ...cloned[index], nameOk: event.target.value.trim().length > 0 };
      setShowGreencheck(cloned);

      // If parent also tracks validation
      props.setObjShowOk?.(cloned);

      const allValid = cloned
        .slice(0, props.numberTickets)
        .every((item) => item.nameOk && item.emailOk);

      setShowOK(
        allValid
          ? "bg-blue-tikets text-white px-6 xl:w-fit w-full sm:w-auto h-32 text-4xl md:text-5xl whitespace-nowrap"
          : "bg-slate-400 text-white px-6 xl:w-fit w-full sm:w-auto h-32 text-4xl md:text-5xl whitespace-nowrap"
      );
};


  const handleChangeEmail = (event) => {
  const index = Number(event.target.id);
  const email = event.target.value.trim();
  const isValid = /\S+@\S+\.\S+/.test(email);

  // Clone to avoid mutating previous state
  const updatedChecks = [...showGreencheck];
  updatedChecks[index] = { 
    ...updatedChecks[index], 
    emailOk: isValid 
  };
  
  setShowGreencheck(updatedChecks);
  props.setObjShowOk?.(updatedChecks);

  // Recompute overall validity
  const allValid = updatedChecks
    .slice(0, props.numberTickets)
    .every(item => item.nameOk && item.emailOk);

  setShowOK(
    allValid
      ? "bg-blue-tikets text-white px-6 xl:w-fit w-full sm:w-auto h-32 text-4xl md:text-5xl whitespace-nowrap"
      : "bg-slate-400 text-white px-6 xl:w-fit w-full sm:w-auto h-32 text-4xl md:text-5xl whitespace-nowrap"
  );

  forceUpdate();
};


  const handleChangeDiscount = async (i) => {
      const discount_code = inputValues[i]?.trim();
      if (!discount_code) return;

      let mergedData = { ...discountData };
      let fetchedData = null;

      try {
        // Fetch if not cached
        if (!mergedData[discount_code]) {
          const response = await fetch(
            `${API_BASE_URL}discount/${CONVENTION_ID}/${encodeURIComponent(discount_code)}?api_token=${API_TOKEN}`,
            { method: "GET" }
          );
          fetchedData = await response.json();
          mergedData[discount_code] = fetchedData.data;
          setDiscountData(mergedData);
        }

        // Recalculate all discounts
        const allCodes = Array.from({ length: props.numberTickets }).map(
          (_, idx) => String(form.current.elements[`discount_${idx}`]?.value || "").trim()
        );

        const updatedChecks = showGreencheck.map((ticket, idx) => {
          const code = allCodes[idx];
          if (!code) return { ...ticket, discountOk: false };

          const data = mergedData[code];
          if (!data?.status) return { ...ticket, discountOk: false };

          const d = data.data;
          let validBase =
            (d.ticket_id === null || d.ticket_id === undefined || d.ticket_id === props.ticketId) &&
            (d.usage_type === "unlimited" ||
              (d.usage_type === "single_use" && d.used === false) ||
              (d.usage_type === "multiple_use" && d.uses_count > 0));

          let valid = validBase;

          // Single-use → only first occurrence valid
          if (d.usage_type === "single_use") {
            const firstIndex = allCodes.findIndex((v) => v === code);
            valid = validBase && idx === firstIndex;
          }

          // Multiple-use → valid up to uses_count
          if (d.usage_type === "multiple_use") {
            const codeIndices = allCodes
              .map((v, j) => (v === code ? j : -1))
              .filter(v => v !== -1);
            valid = validBase && codeIndices.indexOf(idx) < d.uses_count;
          }

          return { ...ticket, discountOk: valid };
        });

        setShowGreencheck(updatedChecks);
        props.setObjShowOk?.(updatedChecks);
        await refresh_total(mergedData);

      } catch (error) {
        console.error("Discount validation failed:", error);
        const updatedChecks = [...showGreencheck];
        updatedChecks[i] = { ...updatedChecks[i], discountOk: false };
        setShowGreencheck(updatedChecks);
        props.setObjShowOk?.(updatedChecks);
      }

      forceUpdate();

  };



  const background = {
    backgroundImage: `url(${bgTickets})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    fontFamily: "Bebas Neue",
  };

  const totalPriceWithDiscount = obj.reduce(
    (total, ticket) => total + props.item.price * (1 - (ticket.discount || 0)),
    0
  );

  const buyTicket = async (e) => {
  e.preventDefault();
  setOpen(false);

  // Ensure any pending totals or discounts are refreshed
  await refresh_total();

  const vatValue = e.target[0]?.value || "";
  const updatedTickets = [];

  // Collect all ticket info directly from the form
  for (let i = 0; i < props.numberTickets; i++) {
    if (!activeTickets[i]) continue;
    const name = form.current.elements[`name_${i}`]?.value || "";
    const email = form.current.elements[`email_${i}`]?.value || "";
    const discount_code = form.current.elements[`discount_${i}`]?.value.trim() || "";

    let discount = 0;
    let discount_id = "";

    // Only apply valid discounts
    if (discount_code && showGreencheck[i]?.discountOk) {
      const data = discountData[discount_code];
      discount = data.percentage;
      discount_id = discount_code;
    }

    updatedTickets.push({
      name,
      email,
      discount,
      discount_id,
      id: props.ticketId,
      vat: vatValue,
      deleteId: i,
    });
  }

  // Build the payload
  const formData = {
    tickets: JSON.stringify(updatedTickets),
    vat: vatValue,
    lang: i18n.language,
  };

  // Create a temporary HTML form for backend submission
  const formEl = document.createElement("form");
  formEl.method = "POST";
  formEl.action = `${API_BASE_URL}checkout?api_token=${API_TOKEN}`;

  // Append all fields
  for (const key in formData) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = key;
    input.value = formData[key];
    formEl.appendChild(input);
  }

  document.body.appendChild(formEl);

  // Perform the submission
  formEl.submit();
  };


  // Sequentially run handleChangeDiscount for every ticket so uses are consumed in DOM order
  const precheckAllDiscounts = async () => {
    for (let i = 0; i < props.numberTickets; i++) {
      try {
        // Await so that each ticket's discount is applied/consumed before moving to the next
        await handleChangeDiscount(i);
      } catch (err) {
        console.error(`Error checking discount for ticket ${i}:`, err);
        // continue — we still want to validate the rest
      }
    }
  };

  // openSummary now ensures every discount was re-checked in-order before computing the final totals
  const openSummary = async (e) => {
    e.preventDefault();

    // 1) Ensure every ticket's discount has been (re)validated in order.
    await precheckAllDiscounts();
    await refresh_total();
    setOpen(true);
  };

  //Refreshes all the data so that all the variables are up to date.
  const refresh_total = async (latestDiscountData = null) => {
    // If form not mounted yet, return early (and return existing cache)
    if (!form?.current) {
      return latestDiscountData || discountData;
    }

    // Start from the passed-in data or the cached state
    const useData = { ...(latestDiscountData || discountData) };

    const updatedObj = [];
    const updatedChecks = [];

    // Collect all codes from form inputs
    const allCodes = Array.from({ length: props.numberTickets }).map((_, idx) =>
      String(form.current.elements[`discount_${idx}`]?.value || "").trim()
    );

    // Find missing (non-empty) codes we don't have locally
    const missingCodes = Array.from(new Set(
      allCodes.filter((c) => c && !useData.hasOwnProperty(c))
    ));

    if (missingCodes.length > 0) {
      try {
        const fetched = await Promise.all(
          missingCodes.map(async (code) => {
            const resp = await fetch(
              `${API_BASE_URL}discount/${CONVENTION_ID}/${encodeURIComponent(code)}?api_token=${API_TOKEN}`,
              { method: "GET" }
            );
            const json = await resp.json();
            let json_data = json.data;
            return { code, json_data };
          })
        );
        fetched.forEach(({ code, json }) => {
          useData[code] = json;
        });

        // Update cache with newly fetched entries (non-blocking)
        setDiscountData((prev) => ({ ...prev, ...useData }));
      } catch (err) {
        // console.error("Error fetching missing discount codes:", err);
      }
    }

    // Validate each ticket's discount using useData (fresh)
    for (let i = 0; i < props.numberTickets; i++) {
      const name = String(form.current.elements[`name_${i}`]?.value || "");
      const email = String(form.current.elements[`email_${i}`]?.value || "");
      const discount_code = allCodes[i] || "";
      let discount = 0;
      let discountOk = false;

      if (discount_code) {
        const d = useData[discount_code];

        const validBase =
          (d.ticket_id === null ||
            d.ticket_id === undefined ||
            d.ticket_id === props.ticketId) &&
          (d.usage_type === "unlimited" ||
            (d.usage_type === "single_use" && d.used === false) ||
            (d.usage_type === "multiple_use" && (d.uses_count > 0)));

        let valid = validBase;

        // single-use: only the first occurrence is valid
        if (d.usage_type === "single_use") {
          const firstIndex = allCodes.findIndex((v) => v === discount_code);
          const occurrences = allCodes.filter((v) => v === discount_code).length;
          valid = validBase && occurrences >= 1 && i === firstIndex;
        }

        // multiple-use: allowed up to uses_count
        if (d.usage_type === "multiple_use") {
            const codeIndices = allCodes
              .map((v, idx) => (v === discount_code ? idx : -1))
              .filter((v) => v !== -1);

            // ✅ Only first N tickets get valid discount
            const allowedIndices = codeIndices.slice(0, d.uses_count);
            valid = allowedIndices.includes(i);
          }

        if (valid) {
          discount = Number(d.percentage) || 0;
          discountOk = true;
        } else {

        }
      }

      updatedChecks.push({
        ...(showGreencheck[i] || { nameOk: false, emailOk: false, discountOk: false }),
        discountOk,
      });

      updatedObj.push({
        name,
        email,
        discount,
        discount_id: discount_code,
        id: props.ticketId,
        deleteId: i,
      });
    }

    setShowGreencheck(updatedChecks);
    setObj(updatedObj);
    setLoading(false);
    forceUpdate();

    // IMPORTANT: return the data we used so callers can read it synchronously
    return useData;
  };

  const clickDeleteHandler = (index) => {
  props.onDeleteTicket?.(index);
};




  // 🧠 JSX below unchanged
  return (
    <>
      <form className="bg-red xl" ref={form} onSubmit={openSummary}>
        <div className="border-b-2 w-48 border-dotted xl:ml-0 ml-6"></div>
        {[...Array(props.numberTickets)].map((_, i) =>
          activeTickets[i] ? (
            <div key={i} className="xl:pl-10 xl:pr-0 px-6">
            <div className="grid grid-cols-6 pt-10 pr-48 pl-10 bg-white content-center"></div>
            <div className="border-2 grid grid-cols-12 py-10 flex items-center bg-white">
              <div className="xl:-ml-16 -ml-5 xl:text-4xl text-xl bg-white col-start-1 col-span-1 border-2 text-center rounded-full xl:h-32 h-10 xl:w-32 w-10 flex justify-center items-center text-blue-tikets">
                {i + 1}.
              </div>
              <div className="col-start-2 xl:col-span-8 col-span-10 -mt-10">
                <div className="grid grid-cols-12 border-b-2 xl:w-11/12 xl:ml-10 ">
                  <div className="relative -ml-10 z-0 xl:w-11/12 mb-3 group col-start-1 col-span-11">
                    <input
                      autoComplete="off"
                      type="text"
                      name={`name_${i}`}
                      id={i}
                      className="block pl-10 py-4 px-0 w-full mt-8 -mb-8 text-2xl text-blue-tikets bg-transparent appearance-none dark:text-blue-tikets dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer placeholder:italic"
                      placeholder={t("home.name-player")}
                      required
                      onChange={handleChangeName}
                    />
                  </div>
                  {showGreencheck[i]?.nameOk && (
                    <img
                      className="self-end sm:place-self-center h-10"
                      src={ti}
                      alt="logo"
                    />
                  )}
                </div>
                <div className="grid grid-cols-12 border-b-2 xl:w-11/12 xl:ml-10 ">
                  <div className="relative -ml-10 z-0 xl:w-11/12 sm:w-2/3 mb-3 group col-start-1 col-span-11">
                    <input
                      autoComplete="off"
                      type="email"
                      name={`email_${i}`}
                      id={i}
                      className="block bold pl-10 py-4 px-0 w-full my-8 -mb-8 text-2xl text-blue-tikets bg-transparent appearance-none dark:text-blue-tikets dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer placeholder:italic"
                      placeholder={t("home.e-mail-player")}
                      required
                      onChange={handleChangeEmail}
                    />
                  </div>
                  {showGreencheck[i]?.emailOk && (
                    <img
                      className="self-end sm:place-self-center h-10"
                      src={ti}
                      alt="logo"
                    />
                  )}
                </div>
              </div>
              <div
                className="text-center xl:col-span-3 col-span-12 xl:ml-10 -mt-4"
                style={{ fontFamily: "sf-pro-regular" }}
              >
                <div className="2xl:text-3xl xl:text-2xl col-span-3 py-4 text-gray-tikets text-center">
                  {t("tickets.discount_code")}
                </div>
                <div className="flex justify-center">
                  <div className="block col-span-3 border-2 mx-2 py-4 px-2 text-center xl:w-9/12 w-10/12 text-2xl text-blue-tikets bg-transparent appearance-none dark:text-blue-tikets dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer flex justify-center">
                    <input
                      style={{ fontFamily: "sf-pro-regular" }}
                      autoComplete="off"
                      type="text"
                      name={`discount_${i}`}
                      id={`discount_${i}`}
                      className="block text-center xl:w-9/12 w-10/12 text-2xl text-blue-tikets bg-transparent focus:outline-none focus:ring-0 flex justify-center"
                      placeholder=" "
                      onChange={()=>{
                        const updatedInputValues = { ...inputValues }
                        updatedInputValues[i] = document.getElementById(`discount_${i}`).value
                        setInputValues(updatedInputValues);
                      }}
                    />
                    {showGreencheck[i]?.discountOk && (
                      <>
                        <img
                          className="place-self-center h-10"
                          src={ti}
                          alt="logo"
                        />
                        <input
                          hidden
                          name={`discount_${i}_check`}
                          value={"true"}
                       />
                    </>
                    )}
                  </div>

                </div>
                <button
                  type="button"
                  style={{ fontFamily: "sf-pro-medium" }}
                  className="col-start-6 bg-blue-tikets text-white p-5 w-10/12 text-2xl mt-10 py-12"
                  onClick={() => handleChangeDiscount(i)}
                  >
                    {t("tickets.checkdiscount")}
                  </button>
              </div>
            </div>
            </div> ) : null
        )}
        <div className="border-b-2 w-48 pt-10 border-dotted xl:ml-0 ml-6 "></div>
        <div className="flex justify-between items-center flex-col sm:flex-row xl:pl-10 xl:items-end">
          <div className="bold text-5xl py-10 sm:ml-5 text-center">
            {t("tickets.total")}{" "}
            <span className="text-blue-tikets">
              {!loading ? totalPriceWithDiscount.toFixed(2) + "€" : 0 + "€"}
            </span>
          </div>
            <div className="flex justify-end w-full px-4 py-6 overflow-hidden">
                <button
                    type="submit"
                    disabled={props.numberTickets === 0}
                    style={{ fontFamily: "sf-pro-regular" }}
                    className={`
                        ${
                            props.numberTickets === 0
                                ? "bg-slate-400 text-white cursor-not-allowed"
                                : showOK
                        }
                              flex items-center justify-center
                              px-4 sm:px-6 md:px-8 lg:px-10
                              py-3 sm:py-4 md:py-5 lg:py-6
                              text-sm sm:text-lg md:text-xl lg:text-2xl xl:text-3xl
                              whitespace-normal text-center
                              break-words
                              text-white font-medium
                              transition-all duration-200 ease-in-out
                              w-full sm:w-auto max-w-full sm:max-w-[95%] md:max-w-[90%] lg:max-w-[80%]
                              box-border
                            `}
                >
                    {t("tickets.proceed_to_payment")}
                </button>
            </div>


        </div>
      </form>

      <Transition.Root
        show={open}
        as={Fragment}
        style={{ fontFamily: "sf-pro-medium" }}
      >
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto justify-self-center">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <div className="xl:w-4/5 flex justify-center ">
                  <Dialog.Panel className="relative transform overflow-hidden bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-full sm:mx-20 mt-20 sm:mt-48 xl:px-16">
                    <div
                      className="flex content-start justify-end flex-wrap sm:pt-0 mt-0"
                      onClick={handleClose}
                      type="button"
                    >
                      <button>
                        <img
                          className="place-self-center h-6 lg:mr-0 mr-4 mt-4 xl:mt-16"
                          src={x3}
                          alt="logo"
                        />
                      </button>
                    </div>
                    <div className="bg-white xl:px-4 px-10 pb-4 pt-5 sm:pt-6 sm:pb-4">
                      <div className="sm:flex sm:items-start">
                        <div className="grid-cols-1 mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                          <div className="grid grid-cols-12">
                            <Dialog.Title
                              as="h3"
                              className="text-3xl xl:col-start-2 col-start-1 xl:col-span-8 col-span-12 text-blue-tikets font-semibold leading-6 flex xl:justify-start justify-center items-center"
                              style={{ fontFamily: "sf-pro-medium" }}
                            >
                              {t("tickets.purchase_checkout")}
                            </Dialog.Title>
                          </div>
                          {loading ? (
                            <div>{t("tickets.loading")}</div>
                          ) : (
                            obj.map((e, i) => (
                                <div key={i} className="w-full flex flex-col gap-4 xl:gap-6">
                                    <div
                                        className="w-full mt-2 xl:py-5 md:py-5 grid grid-cols-12 items-start"
                                    >
                                        {/* Step number */}
                                        <div className="xl:col-start-1 col-span-12 border-2 text-center rounded-full h-24 w-24 xl:h-32 xl:w-32 flex items-center justify-center text-4xl text-blue-tikets">
                                            {i + 1}.
                                        </div>

                                        {/* Ticket container with background */}
                                        <div
                                            className="col-span-12 flex flex-col-reverse md:flex-row relative p-4 sm:p-6 overflow-hidden mt-5 mb-5"
                                            style={background}
                                        >
                                            {/* QR code */}
                                            <div className="flex-shrink-0 flex justify-center items-start mt-4 md:mt-0 md:mr-4 relative z-10">
                                                <img
                                                    src={qr}
                                                    alt="QR code"
                                                    className="w-[150px] sm:w-[180px] md:w-[200px] xl:w-[220px] h-auto object-contain"
                                                />
                                            </div>

                                            {/* Text container */}
                                            <div className="flex-1 flex flex-col justify-start gap-2 relative z-10 min-w-0">
                                                {/* Logo + Event Name */}
                                                <div className="flex flex-col md:flex-row items-center md:items-start gap-2 sm:gap-4 text-center md:text-left" style={{ fontFamily: "sf-pro-regular" }}>
                                                    <img src={logo1} alt="logo" className="w-12 sm:w-16 md:w-20 xl:w-24 h-auto flex-shrink-0" />
                                                    <div className="flex flex-col justify-start text-white min-w-0">
                                                        <div className="text-sm sm:text-lg md:text-xl lg:text-2xl break-words">{props.item.event_name}</div>
                                                        <div className="text-xs sm:text-sm md:text-base lg:text-lg break-words">{e.name}</div>
                                                        <div className="text-xs sm:text-sm md:text-base lg:text-lg break-words">{e.email}</div>
                                                    </div>
                                                </div>

                                                {/* Ticket info */}
                                                <div className="flex flex-col md:flex-row md:justify-between gap-2 mt-4 text-white w-full items-center md:items-start text-center md:text-left">
                                                    {/* LEFT */}
                                                    <div className="flex items-center gap-2 flex-1 min-w-0 justify-center md:justify-start">
                                                        <img src={ticketIcon} alt="ticket" className="w-8 sm:w-10 md:w-12 flex-shrink-0" />
                                                        <div className="text-sm sm:text-base md:text-base leading-4 break-words min-w-0">
                                                            <div>{props.item.name}</div>
                                                            <div>
                                                                {t("tickets.person")},{" "}
                                                                {props.item.from === props.item.to ? props.item.from : (
                                                                    <>
                                                                        {props.item.from}<br />
                                                                        {props.item.to}
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* RIGHT */}
                                                    <div className="flex items-center gap-2 flex-1 min-w-0 mt-2 md:mt-0 justify-center md:justify-start">
                                                        <img src={ticketPin} alt="location" className="w-8 sm:w-10 md:w-12 flex-shrink-0" />
                                                        <div className="text-sm sm:text-base md:text-base break-words min-w-0">{props.item.location}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Price section */}
                                        <div className="col-span-12 flex flex-col justify-start items-start gap-2 mt-4 xl:mt-0">
                                            <div className="text-blue-tikets text-xl sm:text-2xl md:text-3xl 2xl:text-4xl">{props.item.name}</div>
                                            <div className="text-lg sm:text-xl md:text-2xl lg:text-3xl">
                                                {t("tickets.price")}{" "}
                                                <span className="text-blue-tikets">
          {(props.item.price.toFixed(2) - props.item.price.toFixed(2) * e.discount).toFixed(2)}€
        </span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Dotted border */}
                                    <div className="border-b-2 w-48 border-dotted my-4"></div>
                                </div>


                            ))
                          )}

                          <div className="grid place-items-stretch grid-cols-12 pt-10 text-4xl">
                            <div className="lg:col-start-2 col-start-1 col-span-5 text-2xl text-left">
                              {obj.length} x {props.item.name}
                            </div>
                            {/* {isScreenSmall ? (
                              <div className="col-start-1 col-span-5 text-sm pt-2">
                                {props.item.location}
                              </div>
                            ) : (
                              ""
                            )} */}
                            <div className="col-span-12 lg:col-start-10 lg:col-span-3
                                flex justify-end lg:justify-start
                                mt-4 lg:mt-0">
                              <div className="lg:text-left text-right">
                                {t("tickets.total")}{" "}
                                <span className="text-blue-tikets">
                                  {totalPriceWithDiscount.toFixed(2)}€
                                </span>
                              </div>
                            </div>
                            <div className="col-start-10 sm:-ml-0 -ml-16 col-span-4">
                              <div className="lg:text-left text-right text-sm italic">
                                {t("tickets.vat")}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="border-b-2 mx-10 w-48 pt-10 border-dotted"></div>
                    <form className="py-10 sm: py-2" onSubmit={buyTicket}>
                      <div className="relative ml-10 z-0 mr-10 mb-3 group">
                        <button
                          style={{ fontFamily: "sf-pro-medium" }}
                          className="col-start-6 bg-blue-tikets text-white p-5 w-full text-4xl mt-10 py-12"
                          
                        >
                          {t("tickets.proceed_to_payment")}
                        </button>
                      </div>
                    </form>
                  </Dialog.Panel>
                </div>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};

export default TicketForm;
